import { Section } from '@web_opxp/components';
import { AuthSelectors, LanguageSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { AssessmentProgress, AssessmentSelectors, ProgressPageState } from '../assessment';
// This must be imported like this to avoid circular dependencies
import { AssessmentActions } from '../assessment/slice';
import SelectionSection from '../components/SelectionSection/SelectionSection';
import { CyclesSelectors } from '../cycles';
import { IState } from '../store/state';
import TrainingIntensity from './TrainingIntensity.json';
import * as Selectors from './selectors';
import { TrainingIntensityActions } from './slice';

export interface ITrainingIntensitySubpageProps {
  hasCFQ: boolean;
  loading: boolean;
  authorized: boolean;
  started: boolean;
  onStart: () => void;
  onIntensitySelect: (id: number) => void;
}

const TrainingIntensityFC: React.FC<ITrainingIntensitySubpageProps> = ({
  hasCFQ,
  loading,
  authorized,
  started,
  onStart,
  onIntensitySelect,
}) => {
  const { t } = useTranslation();

  React.useEffect(() => {
    if (!authorized || started) {
      return;
    }
    onStart();
  });

  return (
    <>
      <SelectionSection
        loading={loading}
        onSelect={onIntensitySelect}
        selections={TrainingIntensity.intensities}
        title={t('common:TrainingIntensity.Title')}
        type="large"
      />
      <Section>
        <AssessmentProgress page={ProgressPageState.EvaluationDone} cfq={hasCFQ} />
      </Section>
    </>
  );
};

export const mapStateToProps = (state: IState) => {
  const evaluationLoading = Selectors.isEvaluationLoading(state);
  const languageLoading = LanguageSelectors.isLoading(state);
  const hasCFQ = CyclesSelectors.doesCurrentSessionHasCFQWorkouts(state);
  const authorized = AuthSelectors.isAuthorized(state);
  const started = AssessmentSelectors.isAssessmentStarted(state);
  return {
    hasCFQ,
    loading: evaluationLoading || languageLoading,
    authorized,
    started,
  };
};

export const mapDispatchToProps = {
  onStart: AssessmentActions.initAssessment,
  onIntensitySelect: TrainingIntensityActions.trainingIntensitySelected,
};

const TrainingIntensityPage = connect(mapStateToProps, mapDispatchToProps)(TrainingIntensityFC);
export default TrainingIntensityPage;
